module.exports = __webpack_public_path__ + "img/tag.76d97f41.svg";